import { render } from "./BoardDataCount.vue?vue&type=template&id=06c8c2ca&scoped=true"
import script from "./BoardDataCount.vue?vue&type=script&lang=js"
export * from "./BoardDataCount.vue?vue&type=script&lang=js"

import "./BoardDataCount.vue?vue&type=style&index=0&id=06c8c2ca&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c8c2ca"],['__file',"src/components/h5/board/BoardDataCount.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "06c8c2ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('06c8c2ca', __exports__)) {
    api.reload('06c8c2ca', __exports__)
  }
  
  module.hot.accept("./BoardDataCount.vue?vue&type=template&id=06c8c2ca&scoped=true", () => {
    api.rerender('06c8c2ca', render)
  })

}


export default __exports__